import { render, staticRenderFns } from "./KeyInformation.vue?vue&type=template&id=07a3f9a1&scoped=true&"
import script from "./KeyInformation.vue?vue&type=script&lang=js&"
export * from "./KeyInformation.vue?vue&type=script&lang=js&"
import style0 from "./KeyInformation.vue?vue&type=style&index=0&id=07a3f9a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3f9a1",
  null
  
)

export default component.exports